interface Props {}

function TermsAndConditionsPage(props: Props) {
    const {} = props

    return (
      <>Terms And Conditions Page</>  
    )
}

export default TermsAndConditionsPage
